"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _kx = require("@/api/kx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'KxManual',
  data: function data() {
    return {
      timeVal: [],
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        uid: '',
        uidPhone: '',
        status: '',
        payType: '',
        dateLimit: '',
        page: 1,
        limit: 20
      },
      createDialogVisible: false,
      createForm: {
        uid: null,
        amount: 0,
        zoneType: 1,
        payType: 'cash',
        payDesc: '',
        voucherImage: ''
      },
      createRules: {
        uid: [{
          required: true,
          message: '请输入用户UID',
          trigger: 'blur'
        }],
        amount: [{
          required: true,
          message: '请输入消费金额',
          trigger: 'blur'
        }],
        zoneType: [{
          required: true,
          message: '请选择专区类型',
          trigger: 'change'
        }]
      },
      detailDialogVisible: false,
      detailData: null
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    handleReset: function handleReset() {
      this.tableFrom = {
        uid: '',
        uidPhone: '',
        status: '',
        payType: '',
        dateLimit: '',
        page: 1,
        limit: 20
      };
      this.timeVal = [];
      this.getList(1);
    },
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.getList(1);
    },
    getList: function getList(num) {
      var _this = this;
      this.listLoading = true;
      this.tableFrom.page = num || this.tableFrom.page;
      (0, _kx.kxManualListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total || 0;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handleCreate: function handleCreate() {
      var _this2 = this;
      this.$refs.createForm.validate(function (valid) {
        if (!valid) return;
        (0, _kx.kxManualCreateApi)(_this2.createForm).then(function () {
          _this2.$message.success('创建成功');
          _this2.createDialogVisible = false;
          _this2.getList(1);
        });
      });
    },
    handleApprove: function handleApprove(id, approved) {
      var _this3 = this;
      var msg = approved ? '确认通过此入账？通过后系统将自动赠送开心果并触发直推奖' : '拒绝此入账？';
      this.$confirm(msg, '提示', {
        type: approved ? 'success' : 'warning'
      }).then(function () {
        (0, _kx.kxManualApproveApi)({
          id: id,
          approved: approved
        }).then(function () {
          _this3.$message.success(approved ? '审批通过' : '已拒绝');
          _this3.getList();
        });
      }).catch(function () {});
    },
    handleDetail: function handleDetail(id) {
      var _this4 = this;
      (0, _kx.kxManualInfoApi)(id).then(function (res) {
        _this4.detailData = res;
        _this4.detailDialogVisible = true;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};